module.exports = __webpack_public_path__ + "img/xmzt_3.5c2eeb7d.png";